import React from 'react';
import PropTypes from 'prop-types';
import InlineGrid from '../../marvel-ui-grid/InlineGrid';

/**
 * Button groups are used for tab controls, etc.
 */
export default function ButtonGroup({ children }) {
  return <InlineGrid size="none">{children}</InlineGrid>;
}

ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-button/ButtonGroup/index.js